export interface AudioSample {
  url: string;
  startTime: number;
  endTime: number;
}

export interface Score {
  id: string;
  title: string;
  titleReading: string;
  subtitle: string;
  instrumentation: string[];
  category: 'solo' | 'duo' | 'ensemble' | 'full';
  difficulty: 'beginner' | 'intermediate' | 'advanced';
  pages: number;
  price: number;
  description: string;
  imageUrl: string;
  previewUrl: string;
  ensemble?: string;
  audioSample?: AudioSample;
}

export const scores: Score[] = [
  {
    id: '1',
    title: '空-Sora-Beyond',
    titleReading: 'Sora — Beyond',
    subtitle: 'Ensemble "Ro" 大編成',
    instrumentation: ['篠笛', '平胴大太鼓', '跳拍子/締獅子', '地拍子/韻/(沖縄)', '担ぎ桶胴太鼓', '締太鼓', '七寸'],
    category: 'full',
    difficulty: 'intermediate',
    pages: 30,
    price: 2500,
    description: '無限に広がる空を旋律で描いたアンサンブル作品。太鼓芸能集団「鼓童」で演奏されていた曲を2024年に作曲者自ら更新。太鼓ソロのリズムも全て書き下ろされた意欲作。篠笛と太鼓の掛け合いが天へと昇るように積み重なり、境界のない新たな「Beyond」を体感させる。',
    imageUrl: 'https://public.readdy.ai/ai/img_res/13af1e6d56e4b4b1495791d6a4f4debd.jpg',
    previewUrl: 'https://readdy.ai/api/search-image?query=japanese%20ensemble%20music%20score%20notation%20washi%20paper%20sky%20motif%20soft%20preview%20blurred&width=800&height=600&seq=sora_beyond_preview&orientation=landscape',
    ensemble: 'Ro',
  },
  {
    id: 'onogoro',
    title: 'Onogoro',
    titleReading: 'Onogoro',
    subtitle: 'Ensemble "Ni"',
    instrumentation: ['篠笛', '大篳篥', '笙', '箏', '十七絃', '平胴大太鼓', '締太鼓', '拍子木', '地拍子/韻/(沖縄)'],
    category: 'ensemble',
    difficulty: 'advanced',
    pages: 6,
    price: 3000,
    description: '日本神話の創世島「淤能碁呂島」にインスパイアされた作品。天沼矛から滴り落ちた島国日本の神々しい瞬間を太鼓と雅楽器、箏の対話で描き出す。神代の時間感覚を現代アンサンブル語法で再解釈した壮大な組曲。',
    imageUrl: 'https://readdy.ai/api/search-image?query=primordial%20Japanese%20mythological%20island%20rising%20from%20dark%20ocean%2C%20ancient%20creation%20mythology%20Izanagi%20Izanami%2C%20swirling%20dark%20water%20and%20mist%2C%20traditional%20Japanese%20ink%20wash%20painting%20style%2C%20deep%20indigo%20and%20obsidian%20background%2C%20dramatic%20minimal%20composition%2C%20divine%20sacred%20atmosphere%2C%20washi%20texture&width=600&height=800&seq=onogoro_score&orientation=portrait',
    previewUrl: 'https://readdy.ai/api/search-image?query=japanese%20mythology%20music%20score%20notation%20washi%20paper%20dark%20ocean%20motif%20soft%20preview%20blurred&width=800&height=600&seq=onogoro_preview&orientation=landscape',
    ensemble: 'Ni',
    audioSample: {
      url: 'https://on.soundcloud.com/GSlMeBOh1UQr6l8ZfA',
      startTime: 0,
      endTime: 10,
    },
  },
  {
    id: 'harewataru',
    title: '晴れ渡る',
    titleReading: 'Harewataru',
    subtitle: 'Ensemble "Ni"',
    instrumentation: ['篠笛', '篳篥', '笙', '箏', '平胴大太鼓', '太鼓群', '地拍子/韻/(沖縄)'],
    category: 'ensemble',
    difficulty: 'advanced',
    pages: 6,
    price: 3000,
    description: '雲ひとつない晴天が一面に広がる様を、篠笛・篳篥・笙・箏・太鼓のアンサンブルで表現。明るい音粒が光の煌めきを、清澄な旋律が大気を描き出す。演奏者と聴衆が同じ晴れやかな空を共に見上げるような作品。',
    imageUrl: 'https://readdy.ai/api/search-image?query=perfectly%20clear%20Japanese%20sky%20over%20minimalist%20landscape%2C%20cherry%20blossom%20petals%20floating%20upward%2C%20brilliant%20warm%20light%2C%20soft%20white%20clouds%20dissolving%2C%20traditional%20watercolor%20wash%20style%2C%20ivory%20and%20pale%20gold%20tones%2C%20delicate%20washi%20paper%20texture%2C%20serene%20brightness%2C%20refined%20elegant%20aesthetic%20photography&width=600&height=800&seq=harewataru_score&orientation=portrait',
    previewUrl: 'https://readdy.ai/api/search-image?query=japanese%20duo%20koto%20flute%20music%20score%20notation%20washi%20paper%20bright%20sky%20motif%20preview%20blurred&width=800&height=600&seq=harewataru_preview&orientation=landscape',
    ensemble: 'Ni',
    audioSample: {
      url: 'https://on.soundcloud.com/GSlMeBOh1UQr6l8ZfA',
      startTime: 240,
      endTime: 250,
    },
  },
  {
    id: 'en-banquet',
    title: '宴-En-',
    titleReading: 'En — Banquet',
    subtitle: 'Ensemble "Ni"',
    instrumentation: ['篠笛', '篳篥', '笙', '箏', '平胴大太鼓', '太鼓群', '地拍子/韻/(沖縄)', '七寸'],
    category: 'ensemble',
    difficulty: 'advanced',
    pages: 15,
    price: 3000,
    description: '多彩な伝統楽器が絡み合い、宴の熱狂と雅を同時に表現。曼荼羅のような複雑で均整のとれた音響空間を構築し、格調ある雰囲気と高揚を保ち最後は全楽器が渾然一体となる祝祭的フィナーレへと昇華する。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Heian%20period%20ancient%20Japanese%20Suzakumon%20gate%20standing%20alone%20in%20moonlit%20night%2C%20magnificent%20vermillion%20red%20pillars%20and%20sweeping%20traditional%20curved%20rooftile%20eaves%20glowing%20under%20full%20moon%2C%20no%20people%20no%20figures%2C%20stone-paved%20avenue%20stretching%20into%20darkness%2C%20golden%20paper%20lanterns%20casting%20warm%20halo%2C%20ethereal%20mist%20drifting%20across%20deep%20indigo%20sky%2C%20fine%20silk%20painting%20aesthetic%20with%20washi%20paper%20texture%2C%20deep%20crimson%20and%20black%20with%20gold%20accents%2C%20sacred%20ceremonial%20grandeur%2C%20serene%20and%20mysterious%20imperial%20atmosphere%2C%20ultra%20refined%20traditional%20Japanese%20art&width=600&height=800&seq=en_suzakumon_heian_v2&orientation=portrait',
    previewUrl: 'https://readdy.ai/api/search-image?query=japanese%20full%20ensemble%20court%20music%20score%20notation%20washi%20paper%20golden%20festive%20motif%20preview%20blurred&width=800&height=600&seq=en_preview&orientation=landscape',
    ensemble: 'Ni',
    audioSample: {
      url: 'https://on.soundcloud.com/HQWHRVMzCQvJv4UbNR',
      startTime: 254,
      endTime: 264,
    },
  },
  {
    id: 'chirikara-bonten',
    title: 'チリカラ梵天',
    titleReading: 'Chirikara Bonten',
    subtitle: 'Ensemble "Ni"',
    instrumentation: ['胡弓', '三味線', '十七絃', '締太鼓', '地拍子/韻/(沖縄)', '五寸'],
    category: 'ensemble',
    difficulty: 'advanced',
    pages: 11,
    price: 2500,
    description: '胡弓と津軽三味線の早弾き曲に十七絃を加えた特別編成。リズミカルな弦楽器アンサンブルの挑戦、伝統技術の限界に挑戦する。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Buddhist%20cosmic%20mandala%20energy%20Sanskrit%20mantra%20visualization%2C%20swirling%20mystical%20dark%20circles%20and%20light%2C%20deep%20violet%20and%20charcoal%20with%20gold%20ink%20accents%2C%20esoteric%20Japanese%20Buddhist%20art%20style%2C%20abstract%20sacred%20geometry%20minimal%2C%20washi%20paper%20texture%20dark%20background%2C%20meditative%20transcendent%20atmosphere&width=600&height=800&seq=chirikara_score&orientation=portrait',
    previewUrl: 'https://readdy.ai/api/search-image?query=japanese%20chamber%20music%20score%20notation%20washi%20paper%20mandala%20cosmic%20motif%20preview%20blurred&width=800&height=600&seq=chirikara_preview&orientation=landscape',
    ensemble: 'Ni',
    audioSample: {
      url: 'https://on.soundcloud.com/xTsaqVu5fwxl0lzQuR',
      startTime: 0,
      endTime: 10,
    },
  },
  {
    id: 'nami-usagi',
    title: '波兎',
    titleReading: 'Nami-Usagi',
    subtitle: 'Duo',
    instrumentation: ['箏', '篠笛'],
    category: 'duo',
    difficulty: 'advanced',
    pages: 7,
    price: 2000,
    description: '日本古来の「波兎」文様にインスパイアされた二重奏。波の上を跳ねる兎のような軽やかなリズムと、寄せては返す変拍子旋律の波が交互に現れる。箏の波紋と篠笛の弾む音が、日本人の自然観を詩的に表現する。',
    imageUrl: 'https://readdy.ai/api/search-image?query=traditional%20Japanese%20wave%20and%20rabbit%20motif%20nami-usagi%20pattern%2C%20graceful%20white%20rabbit%20silhouette%20leaping%20over%20dark%20stylized%20ocean%20waves%2C%20classic%20Japanese%20woodblock%20print%20aesthetic%2C%20navy%20blue%20and%20white%20ink%2C%20minimalist%20elegant%20washi%20paper%20background%2C%20refined%20traditional%20art%20composition%2C%20elegant%20moonlit%20atmosphere&width=600&height=800&seq=nami_usagi_score&orientation=portrait',
    previewUrl: 'https://readdy.ai/api/search-image?query=japanese%20duo%20koto%20shamisen%20music%20score%20notation%20washi%20paper%20wave%20rabbit%20motif%20preview%20blurred&width=800&height=600&seq=nami_usagi_preview&orientation=landscape',
    audioSample: {
      url: 'https://on.soundcloud.com/gtPWHzihAQh2NCjmxg',
      startTime: 58,
      endTime: 68,
    },
  },
  {
    id: 'tenchikaibyaku',
    title: '天地開闢',
    titleReading: 'Tenchikaibyaku',
    subtitle: 'Ensemble "Ro" Trio',
    instrumentation: ['締太鼓', '平胴大太鼓'],
    category: 'ensemble',
    difficulty: 'intermediate',
    pages: 6,
    price: 1500,
    description: '天と地が分かれる太初の瞬間を描いた組曲。締太鼓と平胴大太鼓の対話が混沌から秩序が生まれる壮大な構成を描く。創世の物語を音響で語り尽くす作品。',
    imageUrl: 'https://readdy.ai/api/search-image?query=ancient%20Japanese%20cosmological%20creation%20of%20heaven%20and%20earth%2C%20primordial%20void%20splitting%20into%20sky%20and%20ground%2C%20dramatic%20burst%20of%20white%20light%20from%20absolute%20darkness%2C%20cosmic%20Japanese%20ink%20painting%20style%2C%20deep%20obsidian%20black%20background%20with%20explosive%20white%20and%20gold%20brushstrokes%2C%20divine%20chaos%20transforming%20to%20order%2C%20monumental%20minimal%20art&width=600&height=800&seq=tenchikaibyaku_score&orientation=portrait',
    previewUrl: 'https://readdy.ai/api/search-image?query=japanese%20full%20ensemble%20creation%20cosmos%20music%20score%20notation%20washi%20paper%20dark%20cosmic%20motif%20preview%20blurred&width=800&height=600&seq=tenchikaibyaku_preview&orientation=landscape',
    ensemble: 'Ro',
  },
  {
    id: 'kazekiri-dagaku',
    title: '風切打楽',
    titleReading: 'Kazekiri Dagaku',
    subtitle: 'Ensemble "Ro" Trio',
    instrumentation: ['担ぎ桶胴太鼓', '地拍子/韻/(沖縄)', '跳拍子/締獅子'],
    category: 'ensemble',
    difficulty: 'intermediate',
    pages: 8,
    price: 1500,
    description: '清風のように軽やかに、風を切るような鋭い打撃、嵐のような連打が交錯する打楽器アンサンブル作品。奏者の身体が風そのものとなり、音の軌跡が空気を可視化する。聴衆とのコールアンドレスポンスによって最後は和やかに締めくくります。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Japanese%20taiko%20percussion%20wind%20cutting%20dynamic%20power%2C%20abstract%20motion%20blur%20ink%20brushstrokes%20slashing%20through%20dark%20space%2C%20sharp%20diagonal%20lines%20suggesting%20fierce%20wind%20and%20drum%20strike%2C%20charcoal%20black%20and%20stark%20white%20with%20silver%20accents%2C%20washi%20paper%20texture%2C%20explosive%20minimalist%20energy%2C%20bold%20traditional%20Japanese%20art%20aesthetic&width=600&height=800&seq=kazekiri_score&orientation=portrait',
    previewUrl: 'https://readdy.ai/api/search-image?query=japanese%20percussion%20solo%20taiko%20music%20score%20notation%20washi%20paper%20wind%20dynamic%20motif%20preview%20blurred&width=800&height=600&seq=kazekiri_preview&orientation=landscape',
    ensemble: 'Ro',
  },
];

export const categoryLabels: Record<string, string> = {
  all: 'すべて',
  solo: 'ソロ',
  duo: 'デュオ',
  ensemble: 'アンサンブル',
  full: '全編成',
};

export const difficultyLabels: Record<string, string> = {
  beginner: '初級',
  intermediate: '中級',
  advanced: '上級',
};
